import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fe8fa88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0 m-0" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "carousel-indicators" }
const _hoisted_4 = ["data-bs-target", "data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_5 = { class: "carousel-inner" }
const _hoisted_6 = { class: "d-flex justify-content-around imgList" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["data-bs-target"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left direction" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["data-bs-target"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right direction" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: 'carouselExampleIndicators_' + _ctx.index,
      class: "carousel slide",
      "data-bs-ride": "carousel"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_ctx.data.length / 3), (item, i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: i,
            class: _normalizeClass(["dd", { active: i === 0 }]),
            type: "button",
            "data-bs-target": '#carouselExampleIndicators_' + _ctx.index,
            "data-bs-slide-to": i + '',
            "aria-current": i === 0 ? true : false,
            "aria-label": 'Slide ' + (i + 1)
          }, null, 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_ctx.data.length / 3), (item, j) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["carousel-item", { active: j === 0 }]),
            key: j
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.url + _ctx.data[item * 3 - 3]?.cover_url,
                class: "d-block"
              }, null, 8, _hoisted_7),
              (_ctx.data[(j + 1) * 3 - 1]?.cover_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.url + _ctx.data[item * 3 - 2]?.cover_url,
                    class: "d-block"
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.data[(j + 1) * 3]?.cover_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.url + _ctx.data[item * 3 - 1]?.cover_url,
                    class: "d-block"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("button", {
        class: "carousel-control-prev",
        type: "button",
        "data-bs-target": '#carouselExampleIndicators_' + _ctx.index,
        "data-bs-slide": "prev"
      }, _hoisted_12, 8, _hoisted_10),
      _createElementVNode("button", {
        class: "carousel-control-next",
        type: "button",
        "data-bs-target": '#carouselExampleIndicators_' + _ctx.index,
        "data-bs-slide": "next"
      }, _hoisted_15, 8, _hoisted_13)
    ], 8, _hoisted_2)
  ]))
}